// Helpers for the SMS two-factor settings card.

/** @type {Array<{key: 'login'|'exportLeads'|'resetPassword', label: string}>} */
export const USE_FOR_OPTIONS = [
  { key: 'login', label: 'Login' },
  { key: 'exportLeads', label: 'Export leads' },
  { key: 'resetPassword', label: 'Reset password' },
];

/** @returns {{login: boolean, exportLeads: boolean, resetPassword: boolean}} All off (the default). */
export const emptyUseFor = () => ({ login: false, exportLeads: false, resetPassword: false });

/**
 * @param {string} phone Any US phone format (+19703165058, 9703165058, …).
 * @returns {string} "970-316-5058" (input returned unchanged if it is not a US number).
 */
export function fmtDashedPhone(phone) {
  const d = String(phone || '').replace(/\D/g, '');
  const ten = d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  return ten.length === 10 ? `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}` : String(phone || '');
}

/**
 * @param {Record<string, boolean>} a
 * @param {Record<string, boolean>} b
 * @returns {boolean} True when any "use 2FA for" flag differs (drives the SAVE button).
 */
export const useForChanged = (a, b) => USE_FOR_OPTIONS.some(({ key }) => !!a?.[key] !== !!b?.[key]);
